import * as React from "react";

import "./textfield.scss";

const sizeClasses = {
  small: "textfield-small",
  large: "textfield-large",
};

const Textfield = (props) => {
  const {
    label,
    id,
    value,
    onChange,
    size,
    leftIcon,
    rightIcon,
    onClickLeftIcon,
    onClickRightIcon,
    onFocus,
    onBlur,
    required,
    hasError,
    errorMessage,
    ...rest
  } = props;

  const [textValue, setTextValue] = React.useState(value || "");

  const [isHovered, setIsHovered] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    setTextValue(value || "");
  }, [value]);

  const onFocusInput = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const onBlurInput = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const onMouseEnterGroup = () => {
    setIsHovered(true);
  };

  const onMouseLeaveGroup = () => {
    setIsHovered(false);
  };
  const onChangeValue = (e) => {
    setTextValue(e.target.value);
    onChange?.(e);
  };

  const inputId = id || `textfield-${Math.floor(Math.random() * 1000)}`;

  return (
    <div className={`box-input ${sizeClasses[size] || ""}`}>
      {label && (
        <label htmlFor={inputId}>
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      <div
        className={`group-input ${hasError ? "error-field" : ""}`}
        onMouseEnter={onMouseEnterGroup}
        onMouseLeave={onMouseLeaveGroup}
      >
        {leftIcon && (
          <label
            htmlFor={inputId}
            className={`icon icon-left ${
              onClickLeftIcon ? "cursor-pointer" : ""
            }`}
            onClick={onClickLeftIcon}
          >
            {leftIcon}
          </label>
        )}
        <input
          id={inputId}
          onChange={onChangeValue}
          value={textValue}
          onFocus={onFocusInput}
          onBlur={onBlurInput}
          required={required}
          {...rest}
        />
        {rightIcon && (
          <label
            htmlFor={inputId}
            className={`icon icon-right ${
              onClickRightIcon ? "cursor-pointer" : ""
            }`}
            onClick={onClickRightIcon}
          >
            {typeof rightIcon === "function"
              ? rightIcon({ isHovered, isFocused })
              : rightIcon}
          </label>
        )}
      </div>
      {hasError && errorMessage && (
        <div className="text-danger">{errorMessage}</div>
      )}
    </div>
  );
};

export default Textfield;
